jQuery(document).ready(function(){

    function sendStat(indent,params){
            var yandex = indent;
            var google = '/'+indent;
            var sendparams = params || false;
            var yaParams = [];
            
            if(sendparams == true) {
                yaParams.push({'URL': document.location.href});
            }


            ym(86442195,'reachGoal', yandex);
    		ga('send', 'pageview', google);
            console.log(indent);
    }


    jQuery('.product-form__buttons .product-form__submit').click(function(){
        sendStat('vkorziny');	
    })

    jQuery('.cart__checkout-button').click(function(){
        sendStat('klick-order');	
    })
    
    jQuery('.shopify-payment-button__button').click(function(){
        sendStat('klik-kypit');	
    })    
    
    jQuery('#cart-notification-form button.button').click(function(){
        sendStat('klick-order');	
    })    
    
    jQuery('#create_customer').submit(function(){
        sendStat('klik-cozdat');	
    })
        
    jQuery('#ContactFooter').submit(function(){
        sendStat('klik-podpiska');	
    })
    
    

});